import { ItemRevision } from 'src/app/models/domain/item-revision';
import { ItemStructure } from './item-structure';

export class ItemRevisionReference extends ItemStructure {
  public constructor(
    public itemUid: string,
    itemId: string,
    itemName: string,
    itemType: string,
    revisions: ItemRevision[]
  ) {
    super(itemId, itemName, itemType, revisions);
  }
}
